<!-- <div class="modal__description m-b-xs-medium m-b-lg-regular font-xs-regular font-lg-medium-big font-color-gray font-weight-bold">Enter the information below to view loan offers through iCreditWorks</div> -->
<div class="modal__main">
    <div class="main__leftpart">
        <div class="leftpart__image leftpart__image_big">
            <img [src]="sharedDataService.assetsCdn('images/dent-and-pony.jpg')" alt="" loading="lazy">
        </div>
    </div>
    <div class="main__rightpart" *ngIf="isSessionTimeout">
        <app-session-timeout-popup style="z-index: 500; position: absolute;" *ngIf="isSessionTimeout && !breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (toClose)="onSessionPopupToClose()" (toContinue)="onSessionPopupContinue()"></app-session-timeout-popup>
        <app-session-timeout-popup style="z-index: 500;" *ngIf="isSessionTimeout && breakpoints.extraSmall" [isMobile]="breakpoints.extraSmall" (toClose)="onSessionPopupToClose()" (toContinue)="onSessionPopupContinue()"></app-session-timeout-popup>
    </div>
    <div class="main__rightpart" *ngIf="!isSessionTimeout">

        <div class="rightpart__header rightpart__header_bg-orange header-smaller">Credit Lock</div>
        <div style="position: relative;" class="rightpart__wrapper border-gray">
             <div class="loader__wrapper" *ngIf="isLoading">
      <div class="loader"></div>
    </div>
            <div class="rightpart__subheader_pseudo flex-column a-items-center">
                Your have frozen your credit file.
            </div>
            <div class="main__rightpart_sory-gray-block">
                <div class="icon icon_credit-lock"></div>
                <div class="contact-paragraph font-lg-large d-xs-none">To unfreeze your credit file,<br>
                    please <strong>contact TransUnion</strong> directy by<br>
                    calling <strong>888-909-8872.</strong></div>
                <div class="contact-paragraph font-lg-large d-xs-flex">To unfreeze your credit file,<br>
                    please <strong>contact TransUnion</strong> directy by<br>
                    calling <strong>888-909-8872.</strong></div>
                <!-- <div class="contact-paragraph font-lg-big d-xs-none">Please contact <strong>TransUnion</strong> and unlock your credit file.<br>Once unlocked, tap continue.</div>
                <div class="contact-paragraph font-lg-big d-xs-flex">Please contact <strong>TransUnion</strong><br>and unlock your credit file.<br>Once unlocked, tap continue.</div> -->
                <div class="transunion-contacts">
                    <div class="transunion-contacts_logo"><span class="font-icon font-icon_transunion-blue"></span></div>
                    <div class="transunion-contacts_link">
                        <span class="icon icon_globus"></span>
                        <a style="font-weight: 400; color: #000" class="wwwTransunionA font-lg-bigger" target="_blank" href="https://www.transunion.com/credit-freeze">www.transunion.com/credit-freeze</a></div>
                </div>
                <div class="phone font-lg-big">
                    <span>After completing this process, <strong>click Continue</strong> to view your Loan Options.</span>
                </div>
                <!-- <div class="phone font-lg-big d-xs-none">
                    <span class="icon icon_call"></span>
                    <span>888-909-8872</span>
                </div>
                <a href="tel:8889098872" class="phone font-lg-big d-xs-flex" style="color: initial;">
                    <span class="icon icon_call"></span>
                    <span>888-909-8872</span>
                </a> -->
                <div (click)="repullFreeze()" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto m-b-xs-medium">Continue</div>
                <!-- <div class="lets-chat"><a role="button" (click)="showChat()">Let’s Chat!</a> We’re here to help.</div> -->
            </div>
        </div>
    </div>
</div>